module.exports = __webpack_public_path__ + "static/grid-item-image-3def0c2c8adf8e6926d34bb1eaee83f6.png";